import MetierLayout from "@/components/MetierLayout";

export default function Syndic() {
  return (
    <MetierLayout
      testid="page-syndic"
      overline="Nos métiers — Syndic"
      title="Syndic de copropriété"
      intro="Une gestion administrative, financière et technique pensée comme un mandat de confiance, dans le strict respect de la loi du 10 juillet 1965 et de son décret d'application."
      image="https://images.unsplash.com/photo-1756674105261-673149ea8bb4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200"
      sections={[
        {
          heading: "Gestion administrative",
          body: [
            "Convocation et tenue des assemblées générales, rédaction des procès-verbaux, suivi des résolutions votées, gestion du conseil syndical et application stricte du règlement de copropriété.",
          ],
          list: [
            "Convocation des AG (ordinaire, extraordinaire)",
            "Animation de séance et rédaction du PV",
            "Mise en application des décisions",
            "Tenue du carnet d'entretien",
            "Gestion des contrats (entretien, fournisseurs, prestataires)",
            "Conservation des documents de la copropriété",
          ],
        },
        {
          heading: "Gestion financière",
          body: [
            "Comptabilité d'engagement tenue sur logiciel agréé, comptes bancaires séparés pour chaque copropriété, appels de fonds trimestriels conformes au budget voté, présentation annuelle des comptes aux copropriétaires.",
          ],
          list: [
            "Budget prévisionnel et appels de fonds",
            "Compte bancaire séparé systématique",
            "Recouvrement amiable et contentieux",
            "Présentation des comptes annuels",
            "Gestion du fonds de travaux (loi ALUR)",
            "Gestion des impayés",
            "Suivi des comptes de la copropriété",
          ],
        },
        {
          heading: "Gestion technique",
          body: [
            "Veille à l'entretien régulier des parties communes, coordonne les interventions des prestataires et accompagne les syndicats des copropriétaires dans la planification et le suivi des travaux, des plus courants aux plus importants.",
          ],
          list: [
            "Visites techniques périodiques",
            "Suivi des contrats d'entretien (chauffage, ascenseur, espaces verts, portail, etc.)",
            "Déclaration et suivi des sinistres",
            "Pilotage des travaux votés en AG",
          ],
        },
      ]}
      cta={{
        label: "Contactez-nous",
        href: "/contact",
      }}
    />
  );
}
